import React from "react";

const Spinner = () => {
  return (
    <div className="loader">
      <div className="spinner"></div>
    </div>
  );
};

export default Spinner;
